import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  EventService,
  GlobalMessageService,
  GlobalMessageType,
  InterceptorUtil,
  OCC_USER_ID_ANONYMOUS,
  OccEndpointsService,
  USE_CLIENT_TOKEN,
  UserIdService
} from '@spartacus/core';
import { Subscription } from 'rxjs';
import { Newsletter } from '../model/custom-newsletter.model';
import { CustomUserActions } from "src/app/spartacus/features/tracking/custom-events/user/store/actions";
import { Store } from "@ngrx/store";

@Injectable({
  providedIn: 'root',
})

export class CustomNewsletterService implements OnDestroy {
  protected subscriptions: Subscription = new Subscription();
  userId: string;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected userIdService: UserIdService,
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected globalMessageService: GlobalMessageService,
    protected eventService: EventService,
    private store: Store,
  ) {
    this.userIdService.takeUserId()
      .subscribe(userID => this.userId = userID)
      .unsubscribe();
  }

  subscribeNewsletter(newsletter: Newsletter, form: any): void {
    const url = this.occEndpoints.buildUrl('newsLetter', {urlParams: {userId: this.userId}});
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    if (this.userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }
    this.subscriptions.add(this.http.post<any>(url, {...newsletter}, {headers}).subscribe({
      next: data => {
        this.store.dispatch(
          new CustomUserActions.NewsletterRegisteredSuccess({
            payload: newsletter
          })
        )

        this.globalMessageService.add(
          {key: 'common.newsletter'},
          GlobalMessageType.MSG_TYPE_CONFIRMATION,
        );
        form.reset();
      },
      error: error =>
        error,
    }));
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
